import { render, staticRenderFns } from "./errorFromServer.vue?vue&type=template&id=adf0002a&"
import script from "./errorFromServer.vue?vue&type=script&lang=js&"
export * from "./errorFromServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports